export default [
    {
        path: '/wv/cyq',
        component: () => import('@/webview/family/cyq.vue')
    },
    {
        path: '/wv/gsz',
        component: () => import('@/webview/family/gsz.vue')
    },
    {
        path: '/wv/mdtp',
        component: () => import('@/webview/family/mdtp.vue'),
        meta:{
            title: '毛豆投屏'
        }
    },
    {
        path: '/wv/fqfl',
        component: () => import('@/webview/family/fqfl.vue'),
        meta:{
            title: ' '
        }
    },
    {
        path: '/wv/chex',
        component: () => import('@/webview/family/chex.vue'),
        meta:{
            title: ' '
        }
    },
    {
        path: '/wv/shopkefu',
        component: () => import('@/webview/family/shopkefu.vue'),
    },
    {
        path: '/wv/tslogin',
        component: () => import('@/webview/family/tslogin.vue'),
    },
    {
        path: '/wv/kefu',
        component: () => import('@/webview/family/kefu.vue'),
    },
    {
        path: '/wv/kefudan',
        component: () => import('@/webview/family/kefudan.vue'),
    },
    {
        path: '/wv/citymanager',
        component: () => import('@/webview/family/citymanager.vue'),
    },
]